module.exports = __webpack_public_path__ + "img/zhiyuan.336439a1.png";